import { render, staticRenderFns } from "./AchievementsWrapper.vue?vue&type=template&id=dfe9927e"
import script from "./AchievementsWrapper.vue?vue&type=script&lang=js"
export * from "./AchievementsWrapper.vue?vue&type=script&lang=js"
import style0 from "./AchievementsWrapper.vue?vue&type=style&index=0&id=dfe9927e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports